<template>
    <div class="row mb-8">
        <div class="col d-flex justify-content-start">
            <span class="title">{{ $t('Delivery.Vehicule.add') }}</span>
        </div>
        <div class="col d-flex gap-2 justify-content-end">
            <genericBtnComponent
                :disabled="loader"
                :ClickFun="createAutoMobile"
                svg="1"
                :Title="$t('Delivery.save')"
                :loader="loader"
            />
        </div>
    </div>

    <v-card elevation="0">
        <div class="row ma-4">
            <div class="col-4">
                <v-card-title>{{ $t('Delivery.Vehicule.marque') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="brand"
                    maxlength="50"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.Vehicule.marque') })"
                    variant="outlined"
                ></v-text-field>
                <span class="warningHint">{{ msg.brand }}</span>
            </div>

            <div class="col-4">
                <v-card-title>{{ $t('Delivery.Vehicule.model') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="model"
                    maxlength="50"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.Vehicule.model') })"
                    variant="outlined"
                ></v-text-field>
                <span class="warningHint">{{ msg.model }}</span>
            </div>

            <div class="col-4">
                <v-card-title>{{ $t('Delivery.Vehicule.Matricule') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="licensePlate"
                    maxlength="20"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.Vehicule.Matricule') })"
                    variant="outlined"
                ></v-text-field>
                <span class="warningHint">{{ msg.licensePlate }}</span>
            </div>
        </div>

        <div class="row ma-4">
            <div class="col-4">
                <v-card-title>{{ $t('Delivery.Vehicule.Capacite') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="maximumLoad"
                    maxlength="10"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.Vehicule.Capacite') })"
                    variant="outlined"
                    type="number"
                ></v-text-field>
                <span class="warningHint">{{ msg.maximumLoad }}</span>
            </div>

            <div class="col-4">
                <v-card-title>{{ $t('Delivery.Vehicule.type') }}</v-card-title>
                <v-autocomplete
                    id="productTypes"
                    name="productTypes"
                    variant="outlined"
                    v-model="selectedProductTypes"
                    persistent-placeholder
                    multiple
                    :placeholder="$t('placeholder.select', { itm: $t('Delivery.Vehicule.type') })"
                    :items="productTypes"
                    item-title="name"
                    item-value="id"
                    hide-details
                    chips
                >
                    <template v-slot:selection="{ item, index }">
                        <v-chip
                            :key="index"
                            closable
                            @click:close="removeProductType(index)"
                            color="primary"
                        >
                            {{ item.name }}
                        </v-chip>
                    </template>
                </v-autocomplete>
            </div>
        </div>
    </v-card>
</template>

<script>
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import { createAutoMobile, getAllProductTypes } from "@/api/index";

export default {
    components: {
        genericBtnComponent,  
    },
    mounted() {
        this.FetchProductsTypes();
    },
    data() {
        return {
            brand: "",
            model: "",
            licensePlate: "",
            maximumLoad: null,
            productTypes: [], 
            selectedProductTypes: [], 
            loader: false,
            msg: {},
        };
    },
    methods: {
        async FetchProductsTypes() {
            try {
                const response = await getAllProductTypes();
                this.productTypes = response.data; 
            } catch (error) {
                console.error("Error fetching product types:", error);
            }
        },

        removeProductType(index) {
            this.selectedProductTypes.splice(index, 1);
        },

        async createAutoMobile() {
            this.loader = true;
            try {
                const formData = new FormData();
                formData.append("Brand", this.brand);
                formData.append("Model", this.model);
                formData.append("LicensePlate", this.licensePlate);
                formData.append("MaximumLoad", this.maximumLoad);

                if (this.selectedProductTypes.length > 0) {
                    this.selectedProductTypes.forEach(id => {
                    formData.append("productCarryingTypes", id);
                });
                }

                await createAutoMobile(formData);
                this.$router.push({ path: "/MyDeliveryCompany" });
                this.$emit("snackbarSuccess", this.$t("Delivery.vehicleCreated"));
            } catch (error) {
                console.error("Error creating vehicle:", error);
                this.$emit("snackbarError", this.$t("Delivery.vehicleCreationFailed"));
            } finally {
                this.loader = false;
            }
        },
    }
};
</script>

<style scoped>
.title {
    margin-top: auto;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
}

.warningHint {
    color: #F25C5C;
    font-size: 14px;
    display: block;
    text-align: left;
}
</style>
